import React from "react"

export type ButtonGroupOption = {
    value: string
    label: string
}

type Props = {
    options: ButtonGroupOption[]
    value: string
    onChange: (value: string) => void
    // Couleur des bordures / texte / fond au survol et à la sélection. Par défaut, l'orange standard
    // défini dans _forms.scss.
    color?: string
    style?: React.CSSProperties
}

export default function ButtonGroup(props: Props) {
    const colorStyle = props.color
        ? ({ "--button-group-color": props.color, "--button-group-text-color": props.color } as React.CSSProperties)
        : undefined

    return (
        <div className="button-group" role="group" style={{ ...colorStyle, ...props.style }}>
            {props.options.map((option: ButtonGroupOption) => (
                <button
                    key={option.value}
                    type="button"
                    className={props.value === option.value ? "selected" : ""}
                    onClick={() => props.onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    )
}
